module.exports = __webpack_public_path__ + "img/product8.b43e9789.png";